<template>
    <div
        v-if="result?.listings?.length > 0"
        class="md-house layout13 mg-bg"
        :style="{ ...spaceStyle, ...colorStyle }"
    >
        <div class="f-col">
            <div class="title-section">
                <div class="title-wrap">
                    <site-title :title="title" />
                    <site-sub-title class="desc" :title="desc" />
                </div>
                <div class="tab">
                    <div
                        :class="{ active: tab == 'forSale' }"
                        @click="changeTab('forSale')"
                        class="tab-item"
                    >
                        {{ $t('md-house.forSale') + ' (' + activeCount + ')' }}
                    </div>
                    <div
                        :class="{ active: tab == 'forSold' }"
                        @click="changeTab('forSold')"
                        class="tab-item"
                    >
                        {{ $t('md-house.forSold') + ' (' + soldCount + ')' }}
                    </div>
                </div>
            </div>
            <Grid />
            <site-button
                v-if="moreShow && moreText"
                type="plain"
                :html="moreText"
                class="button-more"
                :href="moreLink"
                :aria-label="moreLinkPurpose"
                rel="noopener noreferrer"
            />
        </div>
    </div>
    <div v-else-if="waiting" class="waiting"></div>
</template>

<script>
import Core from '../index';
import Grid from './grid.vue';
import { getStore } from '@/store';
import * as TYPES from '../_store/types';
import { mapState } from '@/store/helpers';
import { mapAsyncData } from '@/plugins/asyncData';
import { freshCenterRequest, freshRequest, setFreshResult } from '../async-data';

export default {
    mixins: [Core],
    components: { Grid },
    asyncData: mapAsyncData(async function(store) {
        const searchCenter = getStore.call(this, 'page').isSearchCenter;
        let request = searchCenter ? freshCenterRequest : freshRequest;
        let activeResult = await request.call(this, store, { url: this.asyncLink });
        let soldResult = await request.call(this, store, { url: this.soldAsyncLink });
        store[TYPES.SET_ACTIVE_COUNT](activeResult.counts);
        store[TYPES.SET_SOLD_COUNT](soldResult.counts);
        setFreshResult.call(this, store, activeResult);
    }),
    data() {
        return {
            tab: 'forSale',
        };
    },
    computed: {
        ...mapState({
            activeCount: store => store.activeCount,
            soldCount: store => store.soldCount
        }),
        isSold() {
            if (this.tab == 'forSold') {
                return true;
            } else {
                return false;
            }
        },
        moreLink() {
            if (!this.more) {
                return '';
            }
            let link = this.isSold ? this.more.soldLink : this.more.link;
            let mode = this.more.mode;
            let operator = link.indexOf('?') !== -1 ? '&' : '?';
            mode = mode ? encodeURIComponent(mode) : 'grid';
            let listingStatus = this.isSold ? '' : '&listingStatus=Active';
            return `${link}${operator}mode=${mode}${listingStatus}`;
        }
    },
    methods: {
        async changeTab(tab) {
            this.tab = tab;
            let store = getStore.call(this, this._storeName);
            let result = null
            if (this.isSold) {
                result = await freshRequest.call(this, store, { url: this.soldAsyncLink });
            } else {
                result = await freshRequest.call(this, store, { url: this.asyncLink });
            }
            setFreshResult.call(this, store, result);
        }
    }
};
</script>
<style lang="scss">
@import '@/theme/media.scss';
.md-house.layout13 {
    .title-section {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        gap: 20px;
        .tab {
            height: calc(var(--mg-title-size) * var(--mg-title-line-height));
            display: flex;
            align-items: center;
            gap: 10px;
            .tab-item {
                padding: 6px 15px;
                border-radius: 6px;
                font-family: var(--font-medium);
                font-size: 14px;
                line-height: 1.5;
                color: var(--g-primary-color);
                white-space: nowrap;
                cursor: pointer;
                &.active {
                    background: var(--g-primary-color);
                    color: var(--g-bg-color);
                }
            }
        }
        @include media-800 {
            display: block;
            .tab {
                margin-top: 20px;
            }
        }
    }
    .site-subtitle {
        margin-top: 12px;
        @include media-800 {
            margin-top: 10px;
        }
    }

    .button-more {
        display: flex;
        font-size: 16px;
        width: 200px;
        height: 50px;
        margin: 40px auto 0 auto;
        @include media-800 {
            margin-top: 20px;
        }
    }
}
</style>
